var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"menu",attrs:{"id":"menu"}},[_c('nav',{staticClass:"menu__navigation"},[_c('ul',{staticClass:"menu__items",attrs:{"id":"categories-item"}},_vm._l((_vm.categories),function(category){return _c('menu-item',{key:category.id,attrs:{"categoryId":category.id,"categoryIdent":category.ident,"categoryName":category.name}})}))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dd00304","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Menu.vue
// module id = null
// module chunks = 